import createItemOperation from 'owa-service/lib/operation/createItemOperation';
import CreateItemResponse from 'owa-service/lib/contract/CreateItemResponse';
import itemId from 'owa-service/lib/factory/itemId';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import removeItem from 'owa-service/lib/factory/removeItem';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function removeFromCalendarService(
    item: MeetingCancellationMessageType
): Promise<CreateItemResponse> {
    return createItemOperation({
        Header: getJsonRequestHeader(),
        Body: {
            Items: [
                removeItem({
                    ReferenceItemId: itemId(item.ItemId),
                }),
            ],
            MessageDisposition: 'SendAndSaveCopy',
        },
    }).then(response => response.Body.ResponseMessages.Items[0]);
}
